import { delegate } from 'bobjoll/ts/library/dom';

require('./index.scss');

delegate('.collapse__toggle', 'click', function(this: HTMLButtonElement) {
    if (this.parentElement) {
        this.parentElement.classList.toggle('collapse--show');
    }
});
